import { React, useContext, useState } from "react";

import ThemeContext from "../../lib/theme-context";
import AuthContext from "../../lib/auth-context";

import FormControl from "@mui/material/FormControl";

import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

const ArchivedTestsDropDown = ({
  selectedArchivedTestsBoolean,
  selectedArchivedTests,
  setSelectedArchivedTestsBoolean,
  setSelectedArchivedTests,
  variant = "default",
  fullWidth = false,
}) => {
  const isCompact = variant === "compact";
  const theme = useContext(ThemeContext);
  const auth = useContext(AuthContext);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <FormControl sx={fullWidth ? { width: "100%" } : (isCompact ? { width: 180 } : { width: 260, height: "50px" })} size="small">
      <Select
        MenuProps={{
          PaperProps: {
            sx: isCompact ? {
              maxHeight: 300,
              width: "180px",
              backgroundColor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#fff",
              color: theme[0] === "dark" ? "#FCFCFF" : "black",
              "& .MuiMenuItem-root": {
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            } : fullWidth ? {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",
              minWidth: "200px",
              maxWidth: "400px",
              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            } : {
              bgcolor: theme[0] === "dark" ? "rgba(40, 42, 46)" : "#FCFCFF",
              maxHeight: "450px",
              minWidth: "260px !important",
              maxWidth: "260px !important",
              "& .MuiMenuItem-root": {
                padding: 1.5,
                justifyContent: "center",
                whiteSpace: "nowrap !important",
                overflow: "hidden !important",
                textOverflow: "ellipsis !important",
                display: "block !important",
                textAlign: "center !important",
              },
            },
          },
        }}
        defaultValue=""
        fullWidth
        open={menuOpen}
        onOpen={() => setMenuOpen(true)}
        onClose={() => {
          setTimeout(() => setMenuOpen(false), 200);
        }}
        sx={isCompact ? {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "13px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "6px",
            paddingBottom: "6px",
            paddingLeft: "10px",
            paddingRight: "10px",
          },
        } : {
          backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          color: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          borderRadius: menuOpen ? "12px 12px 0 0" : "12px",
          fontSize: "16px",
          fontWeight: 600,
          transition: "border-radius 0.2s ease-in-out",
          ".MuiSvgIcon-root": {
            fill: theme[0] === "dark" ? "#FCFCFF" : "#1f2937",
          },
          "& fieldset": {
            border: "none",
          },
          "&:hover": {
            backgroundColor: theme[0] === "dark" ? "#434650" : "#d1d5db",
          },
          "&:hover fieldset": {
            border: "none",
          },
          "&.Mui-focused": {
            backgroundColor: theme[0] === "dark" ? "#3a3d45" : "#e5e7eb",
          },
          "&.Mui-focused fieldset": {
            border: "none",
          },
          "& .MuiSelect-select": {
            paddingTop: "8px",
            paddingBottom: "8px",
            paddingLeft: "12px",
            paddingRight: "12px",
          },
        }}
        size="small"
        value={selectedArchivedTests ? selectedArchivedTests : ""}
        onChange={(event) => {
          setSelectedArchivedTestsBoolean(true);
          const {
            target: { value },
          } = event;

          setSelectedArchivedTests(
            typeof value === "string" ? value.split(",") : value
          );
        }}
        displayEmpty
        renderValue={(selected) => {
          if (!selected || selected === "") {
            return (
              <span style={{ 
                color: theme[0] === "dark" ? "#9ca3af" : "#6b7280",
                fontWeight: 600
              }}>
                {selectedArchivedTestsBoolean ? "Test" : "Archived"}
              </span>
            );
          }
          // Parse the JSON string to get the testId
          let displayText;
          try {
            const parsed = JSON.parse(selected);
            if (Array.isArray(parsed) && parsed.length >= 2) {
              displayText = parsed[1]; // Return the testId (second element)
            } else {
              displayText = selected;
            }
          } catch (error) {
            // Fallback if parsing fails
            displayText = selected;
          }
          if (!displayText) {
            displayText = selectedArchivedTestsBoolean ? "Test" : "Archived";
          }
          return (
            <span style={{ fontSize: isCompact ? "13px" : "14px" }}>
              {displayText}
            </span>
          );
        }}
      >
        {auth.backtests
          ?.filter((trades) => trades.archived?.includes("true"))
          .map((test) => (
            <MenuItem
              sx={{
                color: theme[0] === "dark" ? "#FCFCFF" : "rgba(40, 42, 46)",
              }}
              key={test.testId}
              value={JSON.stringify([test._id, test.testId])}
            >
              {test.testId}
            </MenuItem>
          ))}
      </Select>
    </FormControl>
  );
};

export default ArchivedTestsDropDown;
